// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__yOlxq","item":"Breadcrumbs_item__W1tQo","link":"Breadcrumbs_link__VjCkV"};